export enum keyCodes {
  enter = 13,
  space = 32,
  arrowUp = 38,
  arrowDown = 40,
}

export const isEventKey = (e: KeyboardEvent, code: number) => {
  // tslint:disable-next-line
  return e.keyCode === code || e.which === code;
};
